//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'FooterSocial',
  data() {
    return {
    }
  },
  computed: {
    dataFromState: function() {
      return this.$store.state?.appState?.config
    },
    telegramLinkLinzaruBot: function () {
      return this.$store?.state?.appState?.vars?.["telegram_link_linzaru_bot"] || "#"
    },
    title: function () {
      return "Подпишитесь на наши соц. сети"
    },
  },
  methods: {
    copyLink: async function(link) {
      try {
        await this.$copyText(link);
        this.$toast.success('Ссылка скопирована');
      } catch (e) {
        this.$toast.success('Ошибка копирования');
      }
    },
  }
}
